import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-division-dept-form',
  templateUrl: './division-dept-form.component.html',
  styleUrls: ['./division-dept-form.component.css']
})
export class DivisionDeptFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ultilities/division-department/division-dept-form/division-dept-form.component.ts